(function () {
  'use strict';

  function init() {
    const sections = document.querySelectorAll('[data-accordion-list]');
    if (sections.length === 0) return;

    sections.forEach((section) => {
      const items = section.querySelectorAll('[data-accordion-item]');
      if (items.length === 0) return;

      items.forEach((item) => {
        const link = item.querySelector('[data-accordion-link]');
        const content = item.querySelector('[data-accordion-content]');

        link.addEventListener('click', (event) => {
          event.preventDefault();

          if (link.getAttribute('aria-expanded') === 'false') {
            openItem(link, content);

            // DATALAYER
            app.dataLayer.pushEvent('accordionOpen', {
              pageUrl: window.location.pathname,
              option: link.innerText,
            });
          } else {
            closeItem(link, content);
          }
        });
      });
    });

    // Handle initial hash on load
    handleInitialHash();

    // Delegate clicks on in-page anchor links to open accordions first
    document.addEventListener(
      'click',
      (event) => {
        const anchor = event.target.closest && event.target.closest('a[href*="#"]');
        if (!anchor) return;

        // Only handle same-page hashes
        const href = anchor.getAttribute('href');
        if (!href) return;
        const urlHash = href.indexOf('#') >= 0 ? href.slice(href.indexOf('#')) : null;
        if (!urlHash) return;

        // Find target element by id or name
        const id = decodeURIComponent(urlHash.slice(1));
        let target = document.getElementById(id) || document.getElementsByName(id)[0];
        if (!target) return;

        // Only allow linking directly to an accordion item element
        if (!target.matches || !target.matches('[data-accordion-item]')) return;

        event.preventDefault();

        openAccordionElement(target).then(() => {
          // Update hash without causing an extra jump
          try {
            history.pushState && history.pushState(null, '', urlHash);
          } catch (err) {}
          // Ensure visible after open animation
          target.scrollIntoView({ behavior: 'auto', block: 'start' });

          // Set the focus on the accordion link
          const link = target.querySelector('[data-accordion-link]');
          link.focus && link.focus({ preventScroll: true });
        });
      },
      false
    );
  }

  function openItem(link, content) {
    if (link.getAttribute('data-sliding') === 'true') return Promise.resolve(false);

    // a11y: update aria attributes
    link.setAttribute('data-sliding', true);
    link.setAttribute('aria-expanded', true);
    content.setAttribute('aria-hidden', false);

    // Use a promise so callers can wait for the animation to finish before proceeding
    return new Promise((resolve) => {
      util.slideDown(content, 250, () => {
        link.removeAttribute('data-sliding');
        resolve(true);
      });
    });
  }

  function closeItem(link, content) {
    if (link.getAttribute('data-sliding') === 'true') return Promise.resolve(false);

    // a11y: update aria attributes
    link.setAttribute('data-sliding', true);
    link.setAttribute('aria-expanded', false);
    content.setAttribute('aria-hidden', true);

    // Use a promise so callers can wait for the animation to finish before proceeding
    return new Promise((resolve) => {
      util.slideUp(content, 250, () => {
        link.removeAttribute('data-sliding');
        resolve(true);
      });
    });
  }

  function openAccordionElement(element) {
    const link = element.querySelector('[data-accordion-link]');
    const content = element.querySelector('[data-accordion-content]');
    if (!link || !content) return Promise.resolve(false);

    if (link.getAttribute('aria-expanded') === 'true') {
      return Promise.resolve(true);
    }

    // Open and return promise
    return openItem(link, content);
  }

  // On initial load, if URL has a hash that targets an element inside an accordion
  // open it and scroll into view
  function handleInitialHash() {
    const hash = window.location.hash;
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));

    // Find target element by id or name
    let target = document.getElementById(id) || document.getElementsByName(id)[0];
    if (!target) return;

    // Only allow linking directly to an accordion item element
    if (!target.matches || !target.matches('[data-accordion-item]')) return;

    // Open accordion then scroll
    openAccordionElement(target).then((success) => {
      if (!success) return;

      try {
        history.replaceState && history.replaceState(null, '', hash);
      } catch (err) {}

      // Ensure visible after open animation
      target.scrollIntoView({ behavior: 'auto', block: 'start' });

      // Set the focus on the accordion link
      const link = target.querySelector('[data-accordion-link]');
      link.focus && link.focus({ preventScroll: true });
    });
  }

  init();
})();
